import React from 'react';
import { Input } from '@roger/ui-components';
import type { ContactInformationFormProps } from '../types';

const ContactInformationForm: React.FC<ContactInformationFormProps> = ({
  contactInformation,
  onChange,
  required = false,
}) => {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
      <div>
        <label className='block text-sm font-medium mb-1'>
          Contact Name {required && <span className='text-red-500'>*</span>}
        </label>
        <Input
          value={contactInformation?.name || ''}
          onChange={e => onChange('name', e.target.value)}
          placeholder='Contact name'
          required={required}
        />
      </div>

      <div>
        <label className='block text-sm font-medium mb-1'>
          Phone Number {required && <span className='text-red-500'>*</span>}
        </label>
        <Input
          value={contactInformation?.phoneNumber || ''}
          onChange={e => onChange('phoneNumber', e.target.value)}
          placeholder='Phone number'
          required={required}
        />
      </div>

      <div>
        <label className='block text-sm font-medium mb-1'>Email</label>
        <Input
          type='email'
          value={contactInformation?.email || ''}
          onChange={e => onChange('email', e.target.value)}
          placeholder='Email address'
        />
      </div>

      <div>
        <label className='block text-sm font-medium mb-1'>Fax Number</label>
        <Input
          value={contactInformation?.faxNumber || ''}
          onChange={e => onChange('faxNumber', e.target.value)}
          placeholder='Fax number'
        />
      </div>
    </div>
  );
};

export default ContactInformationForm;
